<template>
  <div class="flex items-center gap-2">
    <img :src="currentIcon" v-if="hasIcon" />
    <p :class="textColor" class="text-sm font-medium capitalize">
      {{ text === "Pushed_MID" ? "Pushed" : text }}
    </p>
  </div>
</template>

<script>
import redEllipse from "../../../../assets/svg/red-ellipse.svg";
import greenEllipse from "../../../../assets/svg/green-ellipse.svg";
import grayEllipse from "../../../../assets/svg/grey-ellipse.svg";
import yellowEllipse from "../../../../assets/svg/yellow-ellipse.svg";
import blueEllipse from "../../../../assets/svg/blue-ellipse.svg";
import blackEllipse from "../../../../assets/svg/black-ellipse.svg";
import { lowerCase } from "@/core/helpers/utility";
export default {
  name: "StatusColumn",
  props: {
    text: {
      type: String,
      required: false,
    },
    hasIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      textColor: "text-gray-600",
      redEllipse,
      greenEllipse,
      grayEllipse,
      yellowEllipse,
      blackEllipse,
      blueEllipse,
      currentIcon: "",
    };
  },
  mounted() {
    this.checkStatus();
  },
  watch: {
    text(newVal, oldVal) {
      this.checkStatus();
    },
  },
  methods: {
    checkStatus() {
      // console.log("status tag", this.text.trim());
      // else if (text == "pending") {
      //   this.textColor = "text-[#000]";
      //   this.currentIcon = this.blackEllipse;
      // }
      let text = this?.text?.trim().toLowerCase();
      if (
        text == "connected" ||
        text == "all approved" ||
        text == "all accepted" ||
        text == "accepted" ||
        text == "confirmed" ||
        text == "paid" ||
        text == "fulfilled" ||
        text == "active" ||
        text == "true" ||
        text == "approved" ||
        text == "transaction approved" ||
        text == "approved or completed successfully" ||
        text == "open" ||
        text == "activated"
      ) {
        // console.log("geting here");
        this.textColor = "text-estationsGreen-700";
        this.currentIcon = this.greenEllipse;
      } else if (
        text == "offline" ||
        text == "all denied" ||
        text == "declined" ||
        text == "not fixing" ||
        text == "not fixed" ||
        text == "rejected" ||
        text == "due" ||
        text == "overdue" ||
        text == "deactivated" ||
        text == "expired" ||
        text == "false" ||
        text == "closed" ||
        text == "not activated"
      ) {
        this.currentIcon = this.redEllipse;
        this.textColor = "text-[#D44333]";
      } else if (text == "faulty" || text == "part paid") {
        this.textColor = "text-[#BC8B2C]";
        this.currentIcon = this.yellowEllipse;
      } else if (text == "disconnected") {
        this.textColor = "text-gray-500";
        this.currentIcon = this.grayEllipse;
      } else if (lowerCase(this.text) == "online") {
        this.textColor = "text-blue-500";
        this.currentIcon = this.blueEllipse;
      } else if (
        text == "partially approved" ||
        text == "fixed" ||
        text == "pushed_mid"
      ) {
        this.textColor = "text-blue-500";
        this.currentIcon = this.blueEllipse;
      } else if (lowerCase(this.text) === "active") {
        this.textColor = "text-estationsGreen-700";
        this.currentIcon = this.greenEllipse;
      } else if (
        text == "suspended" ||
        text == "partially accepted" ||
        text == "submitted" ||
        text == "pending"
      ) {
        this.textColor = "text-[#BC8B2C]";
        this.currentIcon = this.yellowEllipse;
      } else if (text == "pending approval" || text == "fixing") {
        this.textColor = "text-[#000]";
        this.currentIcon = this.blackEllipse;
      }
    },
  },
};
</script>

<style>
/* table columns styling options */
.positive {
  font-weight: 500;
  font-size: 14px;
  color: #155c22;
}

.negative {
  font-weight: 500;
  font-size: 14px;
  color: #e11900;
}
</style>
